;(function ($) {

  $.fn.jPushMenu = function (customOptions) {
    var o = $.extend({}, $.fn.jPushMenu.defaultOptions, customOptions)

    $('body').addClass(o.bodyClass)
    $(this).addClass('jPushMenuBtn')
    $(this).click(function () {

      var target = '',
        push_direction = '',
        opposite_menu = '',
        opposite_button = '',
        opposite_dir = ''

      if ($(this).is('.' + o.showLeftClass)) {
        target = '.spmenu-search'
        push_direction = 'toright'
        opposite_menu = '.spmenu-nav'
        opposite_button = '.push-right'
        opposite_dir = 'toleft'
      }
      else if ($(this).is('.' + o.showRightClass)) {
        target = '.spmenu-nav'
        push_direction = 'toleft'
        opposite_menu = '.spmenu-search'
        opposite_button = '.push-left'
        opposite_dir = 'toright'
      }

      // window.console && console.log('Opening ' + target)
      $(opposite_menu).removeClass(o.menuOpenClass)
      $(opposite_button).removeClass(o.activeClass)
      $('body').removeClass('spmenu-push-' + opposite_dir)
      $(this).toggleClass(o.activeClass)
      $(target).toggleClass(o.menuOpenClass)

      if ($(this).is('.' + o.pushBodyClass)) {
        $('body').toggleClass('spmenu-push-' + push_direction)
      }

      /* disable all other button*/
      //jq('.jPushMenuBtn').not(jq(this)).toggleClass('disabled');

      return false
    })
    var jPushMenu = {
      close: function (o) {
        $('.jPushMenuBtn,body,.spmenu').removeClass('disabled active spmenu-open spmenu-push-toleft spmenu-push-toright')
      }
    }

    if (o.closeOnClickInside) {
      $(document).click(function () {
        jPushMenu.close()
      })

      $('.spmenu,.toggle-menu').click(function (e) {
        e.stopPropagation()
      })
    }

    if (o.closeOnClickOutside) {
      $(document).click(function () {
        jPushMenu.close()
      })

      $('.spmenu,.toggle-menu').click(function (e) {
        e.stopPropagation()
      })
    }
  }

  /* in case you want to customize class name,
  *  do not directly edit here, use function parameter when call jPushMenu.
  */
  $.fn.jPushMenu.defaultOptions = {
    bodyClass: 'spmenu-push',
    activeClass: 'menu-active',
    showLeftClass: 'menu-left',
    showRightClass: 'menu-right',
    menuOpenClass: 'spmenu-open',
    pushBodyClass: 'push-body',
    closeOnClickOutside: true,
    closeOnClickInside: true
  }

})(jQuery)
